import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import Icon from './Icon'

/* "inline" is needed for lists in table style */
const StyledSelectedIndicator = styled.span`
  position: ${({ inline }) => (inline ? 'relative' : 'absolute')};
  top: ${({ inline }) => (inline ? 'auto' : '16px')};
  right: ${({ inline }) => (inline ? 'auto' : '16px')};

  width: ${({ inline }) => (inline ? '20px' : '28px')};
  height: ${({ inline }) => (inline ? '20px' : '28px')};
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  color: ${(props) => props.theme.colors.background};
  background: ${(props) => props.theme.colors.brandPrimary};
  font-size: 20px;
  font-weight: bold;
`

const SelectedIndicator = ({ inline = false }) => (
  <StyledSelectedIndicator inline={inline}>
    <Icon name="check" small bordered={false} color="currentColor" />
  </StyledSelectedIndicator>
)

SelectedIndicator.propTypes = {
  inline: PropTypes.bool,
}

export default SelectedIndicator
